import { Component, Input, OnInit } from '@angular/core';

import { ViewCell } from 'ng2-smart-table';

// https://github.com/akveo/ng2-smart-table/issues/303
@Component({
  template: `
    <p style="text-align: center; margin: 0"><i class="{{renderValue}}"></i></p>
  `,
})
export class BooleanRenderComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  ngOnInit() {
    // console.log('[BooleanRenderComponent] Value=' + this.value);
    this.renderValue = this.value ? 'ion-checkmark-round text-success' : 'ion-close-round text-danger';
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/boolean-renderer.ts